import { create } from 'zustand'

/** A ringing inbound call offered to every online agent. */
export interface IncomingCall {
  /** Meta's call id. */
  id: string
  wabaId: string
  customerId: number | null
  customerName: string
  waId: string
  /** Business number being called (several numbers per company). */
  businessPhone: string
  /** Meta's SDP offer — answered by whichever agent accepts. */
  sdp: string
}

/** The one call this tab is on (or placing). */
export interface ActiveCall {
  /** Meta's call id; null until the start request returns it. */
  id: string | null
  wabaId: string
  direction: 'inbound' | 'outbound'
  customerId: number | null
  customerName: string
  waId: string
  /** connecting = mic/SDP setup or waiting on the API. */
  status: 'connecting' | 'ringing' | 'ongoing'
  /** epoch ms the media connected (drives the timer). */
  startedAt: number | null
  muted: boolean
}

interface CallStore {
  incoming: IncomingCall | null
  active: ActiveCall | null
  /** The agent silenced the ring of the current incoming call. */
  ringSilenced: boolean
  /** The browser blocked the ring sound in this tab (page never clicked). */
  ringBlocked: boolean
  setIncoming: (call: IncomingCall | null) => void
  setRingSilenced: (silenced: boolean) => void
  setRingBlocked: (blocked: boolean) => void
  setActive: (call: ActiveCall | null) => void
  patchActive: (patch: Partial<ActiveCall>) => void
}

export const useCallStore = create<CallStore>()((set) => ({
  incoming: null,
  active: null,
  ringSilenced: false,
  ringBlocked: false,

  setIncoming: (incoming) => set({ incoming, ringSilenced: false, ringBlocked: false }),

  setRingSilenced: (ringSilenced) => set({ ringSilenced }),

  setRingBlocked: (ringBlocked) => set({ ringBlocked }),

  setActive: (active) => set({ active }),

  patchActive: (patch) =>
    set((state) => (state.active ? { active: { ...state.active, ...patch } } : state)),
}))
